import { render, staticRenderFns } from "./create-ledger-action.vue?vue&type=template&id=54df36c5"
import script from "./create-ledger-action.ts?vue&type=script&lang=js&external"
export * from "./create-ledger-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports